import React from 'react'
import grn from '../Assets/green_bg.png'
import red from '../Assets/red_bg.png'

const K3Ball = ({ addBall, i }) => {
  return (
    <div onClick={() => addBall(i)} className='flex flex-col justify-center items-center'>

    <div className='relative cursor-pointer flex justify-center items-center'>
        { i % 2 !== 0 && <img className='image max-w-[34px] max-h-[34px]' src={red} alt='' />}      
        { i % 2 === 0 && <img className='max-w-[34px] max-h-[34px]' src={grn} alt=''/>}
        <p className={`absolute text-center font-bold ${i % 2 !== 0 && 'text-red-500'} ${i % 2 === 0  && 'text-green-500'}`}>{i}</p>
    </div>
    </div>
  )
}

export default K3Ball